<template>
  <section class="cover">
    <div class="image-wrapper">
      <BgImage :src="imageUrl" :alt="title" />
      <div class="overlay" v-if="overlay"></div>
    </div>
    <div class="content-wrapper pt-8 lg:py-0 px-4 md:px-8" v-if="title || description">
      <h1 class="page-title lg:text-white text-left">{{ title }}</h1>
      <p class="lg:text-white mt-4">{{ description }}</p>
    </div>
  </section>
</template>
  
<script setup>
defineProps({
  imageUrl: {
      type: String,
      default: '',
  },
  overlay: {
    type: Boolean,
    default: true
  },
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  }
});
</script>
  
<style lang="scss" scoped>
  .cover {
    position: relative;
    .image-wrapper {
      position: relative;
      width: 100%;
      aspect-ratio: 2.8/1;
    }
    @media (max-width: 767px), (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) {
      position: static;
      .image-wrapper {
        aspect-ratio: 2/1;
      }
    }
    .content-wrapper {
      z-index: 3;
      position: absolute;
      width: 450px;
      top: 50%;
      transform: translateY(-50%);
      left: 10rem;
      @media (max-width: 767px), (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: portrait) {
        top: 100%;
        transform: none;
        position: static;
        width: 100%;
        color: $brand-secondary;
        left: 0;
      }
      @media (max-width: 767px), (min-device-width: 390px) and (max-device-width: 844px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) { 
        top: 100%;
        transform: none;
        position: static;
        width: 100%;
        color: $brand-secondary;
        left: 0;
      }
    }
  }
</style>